import StoreDefinition from '../StoreDefinition'

export default new StoreDefinition()
  .prop('loading', true)
  .prop('showJobProgress', null)
  .end()
